import { AxiosError } from 'axios'

import { httpClient } from 'shared/lib'
import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'

import { DeleteWatchedProductPayload, FetchWatchedProductsResult } from './types'

export function fetchWatchedProducts(): Promise<FetchWatchedProductsResult> {
   let errMessage = ''

   return httpClient
      .get('products/observed/')
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('WATCHLIST fetchWatchedProducts service', errMessage, 'error')
         throw error
      })
}

export function removeWatchedProduct(payload: DeleteWatchedProductPayload) {
   let errMessage = ''

   return httpClient
      .delete<Result>(`products/observed/${payload.uuid}`)
      .then((res) => ({ status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('WATCHLIST removeWatchedProducts service', errMessage, 'error')
         throw error
      })
}
